export default __webpack_public_path__ + "static/media/documentIcon.64e653ec.svg";